import React, { Component } from 'react';
import ActionEditorContainer from '../ActionEditorContainer';
import ActionSlackEditorComponent from './ActionSlackEditorComponent';

class ActionSlackEditorContainer extends Component {
  public render() {
    return <ActionEditorContainer editor={<ActionSlackEditorComponent />} type='slack' icon='slack' />;
  }
}

export default ActionSlackEditorContainer;
